var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoApmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1778_4347)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1778_4347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 31,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 19.4215H32.6818V30.75H43.9545V35.2041C43.5069 35.1308 43.0233 35.0829 42.5546 35.0829V36.4927C46.4212 36.4927 49.5783 39.6436 49.5924 43.5149C49.5994 45.3969 48.8745 47.1705 47.55 48.507C46.2269 49.8434 44.4619 50.5836 42.5532 50.5906C38.6881 50.5906 35.5323 47.4411 35.5169 43.5684C35.5028 39.6816 38.674 36.5082 42.5546 36.4927V35.0829C37.859 35.1012 34.091 38.902 34.1093 43.5741C34.1206 46.474 35.5886 49.0678 37.8168 50.5833H21.4076V19.4215ZM43.9545 29.3333H34.0909V19.8219L43.9545 29.3333ZM42.5532 52C47.2516 51.9831 51.0182 48.1799 51 43.5092C50.9859 39.8269 48.6475 36.7112 45.3636 35.5622V29.3333L34.0909 18H20V52H39.7057C40.9378 52 41.887 52 42.5532 52ZM47.0239 46.9139L44.5339 44.4214L43.5388 45.4181L46.0287 47.9106L47.0239 46.9139ZM38.0865 39.9571L40.575 42.4496L41.5702 41.4529L39.0816 38.9604L38.0865 39.9571ZM38.0865 46.9139L39.0816 47.9106L41.5702 45.4181L40.575 44.4214L38.0865 46.9139ZM47.0239 39.9571L46.0287 38.9604L43.5388 41.4529L44.5339 42.4496L47.0239 39.9571ZM36.9091 44.1396H40.4574V42.7284H36.9091V44.1396ZM44.6519 44.1396H48.1818V42.7284H44.6519V44.1396ZM43.2584 45.5367V49.1667H41.8508V45.5367H43.2584ZM43.2584 37.8333V41.3355H41.8508V37.8333H43.2584Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1778_4347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4076 19.4215H32.6818V30.75H43.9545V35.2041C43.5069 35.1308 43.0233 35.0829 42.5546 35.0829V36.4927C46.4212 36.4927 49.5783 39.6436 49.5924 43.5149C49.5994 45.3969 48.8745 47.1705 47.55 48.507C46.2269 49.8434 44.4619 50.5836 42.5532 50.5906C38.6881 50.5906 35.5323 47.4411 35.5169 43.5684C35.5028 39.6816 38.674 36.5082 42.5546 36.4927V35.0829C37.859 35.1012 34.091 38.902 34.1093 43.5741C34.1206 46.474 35.5886 49.0678 37.8168 50.5833H21.4076V19.4215ZM43.9545 29.3333H34.0909V19.8219L43.9545 29.3333ZM42.5532 52C47.2516 51.9831 51.0182 48.1799 51 43.5092C50.9859 39.8269 48.6475 36.7112 45.3636 35.5622V29.3333L34.0909 18H20V52H39.7057C40.9378 52 41.887 52 42.5532 52ZM47.0239 46.9139L44.5339 44.4214L43.5388 45.4181L46.0287 47.9106L47.0239 46.9139ZM38.0865 39.9571L40.575 42.4496L41.5702 41.4529L39.0816 38.9604L38.0865 39.9571ZM38.0865 46.9139L39.0816 47.9106L41.5702 45.4181L40.575 44.4214L38.0865 46.9139ZM47.0239 39.9571L46.0287 38.9604L43.5388 41.4529L44.5339 42.4496L47.0239 39.9571ZM36.9091 44.1396H40.4574V42.7284H36.9091V44.1396ZM44.6519 44.1396H48.1818V42.7284H44.6519V44.1396ZM43.2584 45.5367V49.1667H41.8508V45.5367H43.2584ZM43.2584 37.8333V41.3355H41.8508V37.8333H43.2584Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0455 12.3333H12.9546V57.6666H58.0455V12.3333Z",
    fill: "#707070"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_4347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 34,
    fill: "white",
    transform: "translate(20 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApmIcon);
export default __webpack_public_path__ + "static/media/noApmIcon.ebde184f.svg";
export { ForwardRef as ReactComponent };